"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var ClaimsTableRow_1 = require("./ClaimsTableRow");
var ClaimsTable = /** @class */ (function (_super) {
    __extends(ClaimsTable, _super);
    function ClaimsTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClaimsTable.prototype.render = function () {
        return this.props.claims && this.props.claims.length > 0 && ((0, jsx_runtime_1.jsxs)("table", { className: "table table-striped table-hover table-sm", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { scope: "col", children: "ID" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Type" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Incident date" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Any claim spend?" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "NCD allowed?" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderClaimsTableRows() })] }));
    };
    ClaimsTable.prototype.renderClaimsTableRows = function () {
        var _this = this;
        return this.props.claims.map(function (claim, index) {
            return (0, jsx_runtime_1.jsx)(ClaimsTableRow_1.ClaimsTableRow, __assign({ claim: claim }, _this.props), index);
        });
    };
    ClaimsTable = __decorate([
        components_1.authorize
    ], ClaimsTable);
    return ClaimsTable;
}(React.Component));
exports.ClaimsTable = ClaimsTable;
//# sourceMappingURL=ClaimsTable.js.map